import React from "react";
import Select from "react-select";
import { sortObjectsByAlphabet } from "../../utils";

function DeviceTypeField({ deviceTypes, value, onChange }) {
    const handleChange = (selectedOption) => {
        if (!selectedOption) return;
        const deviceType = deviceTypes.find(type => type.id === Number(selectedOption.value));
        onChange(deviceType);
    }

    const deviceTypesCopy = sortObjectsByAlphabet(deviceTypes, 'name');
    const options = deviceTypesCopy?.map(device => ({
        value: String(device.id),
        label: device.name
    })) || [];

    const selectedOption = value ? options.find(opt => opt.value === String(value.id)) : null;

    return (
        <div className="oct_syslog-text-v2">
            <div>
                <h3 className="text-base font-bold text-slate-800 mb-1">Device Type</h3>
                <p className="text-xs text-slate-500 mb-0">Select the device type to configure syslog events</p>
            </div>

            <Select
                id="deviceType"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={selectedOption}
                onChange={handleChange}
                options={options}
                placeholder="Choose Device Type"
                isSearchable={true}
            />
        </div>
    );
}

export default DeviceTypeField;
